import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: 'What areas do you service?',
    answer: 'Busy Drones Cleaners operates primarily in Yuma, Arizona, covering nearby cities including Somerton, San Luis, Wellton, Fortuna Foothills, Phoenix, Scottsdale, Casa Grande, and Tucson. In California, we serve El Centro, Calexico, Imperial, Brawley, El Cajon, Chula Vista, San Diego, and surrounding locations.\n\nIf your property is outside these regions, contact us directly to check availability and scheduling options.'
  }, {
    question: 'Are your pilots licensed to fly?',
    answer: 'All drone operators at Busy Drones Cleaners hold FAA Part 107 certifications. This ensures every flight meets federal safety and operational standards.\n\nOur licensed pilots undergo regular training to maintain compliance and deliver precise cleaning services.'
  }, {
    question: 'Are you insured?',
    answer: 'We maintain a comprehensive $1 million insurance policy covering all drone cleaning operations. This protects both our team and your property throughout the service.\n\nOur insurance and bonding provide peace of mind for every project, large or small.'
  }, {
    question: 'How long does the service last?',
    answer: 'Typical cleaning appointments vary by property size and condition but usually take a few hours to complete.\n\nWe recommend scheduling cleanings once or twice annually, adjusting frequency based on environmental factors and surface types.'
  }, {
    question: 'How much does it cost?',
    answer: 'Our drone cleaning services often cost less than traditional methods due to lower labor and equipment expenses.\n\nWe offer free estimates and discounts through our Hive Membership programs to provide added value.'
  }, {
    question: 'What about FAA rules and regulations?',
    answer: 'Busy Drones Cleaners manages all FAA compliance internally, including permits and flight restrictions.\n\nYou can trust that every operation is conducted legally and safely without requiring your involvement in regulatory details.'
  }];
  return <section className="bg-[#F5F7FA] py-20 lg:py-28 font-heading" data-id="element-26">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A5C] mb-4 uppercase tracking-tight" data-id="element-29">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full bg-white rounded-xl shadow-sm p-6" data-id="element-30">
          {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="border-b border-[#1B3A5C]/10 last:border-0" data-id="element-31">
              <AccordionTrigger className="text-left text-lg font-bold text-[#1B3A5C] hover:text-[#F5A623] transition-colors py-6" data-id="element-32">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[#1E1E1E] leading-relaxed pb-6 text-base" data-id="element-33">
                {faq.answer.split('\n\n').map((paragraph, i) => <p key={i} className={i > 0 ? 'mt-3' : ''} data-id="element-34">
                    {paragraph}
                  </p>)}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}